import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:라이브챗 상품검색
 * 세부설명:
*/

export class LiveChatGoods extends Component {
    static displayName = LiveChatGoods.name;

    constructor(props) {
        super(props);
        this.state = {
            SearchText: "",
            SelectGoods_No:0,
            ChatGoodsList: []
        };

        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handle_KeyDown = this.handle_KeyDown.bind(this);
        this.handleSearch_Blur = this.handleSearch_Blur.bind(this);
        this.handleSelectGoods_Click = this.handleSelectGoods_Click.bind(this);
        this.handleSend_Click = this.handleSend_Click.bind(this);

        this.CsName = Big3Common.ContentState;
        this.Uid = ""; 
        if (this.props.ContentState !== undefined) {
            this.Uid = this.props.ContentState[this.CsName.Uid] !== undefined ? this.props.ContentState[this.CsName.Uid] : "";
        }
    }
    //초기화
    componentDidMount() {
        this.CallLiveChatGoodsData("");
    }
    //주문문의 조회
    async CallLiveChatGoodsData(Goods_nm) {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Chat/LiveChat/GetSearchGoodsList', {
                uid: this.Uid,
                goods_nm: Goods_nm
            });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let ChatGoodsList = JSON.parse(Data.dataTable);
                this.setState({
                    ChatGoodsList: ChatGoodsList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallLiveChatGoodsData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handle_KeyDown(event) {
        if (event.key === 'Enter') {
            const value = event.target.value;
            this.CallLiveChatGoodsData(value);
        }
        return false;
    }
    //검색 TextBox
    handleSearch_Blur(event) {
        const value = event.target.value;
        this.setState({ SearchText: value });
        event.preventDefault();
    }
    //검색어 초기화
    handleClear_Click = (event) => {
        this.setState({ SearchText: "" });
        this.CallLiveChatGoodsData("");      
        event.preventDefault();
    }
    //상품선택
    handleSelectGoods_Click = (event, Goods_No) => {
        this.setState({ SelectGoods_No: Goods_No });
        event.preventDefault();
    }
    //선택상품 전송
    handleSend_Click = (event) => {
        if (this.state.SelectGoods_No === 0) {
            Big3Common.ModalAlert(bootstrap, 'LiveChatGoodsAlert');
            return false;
        }
        const ContentState = this.props.ContentState;
        ContentState.Goods_No = this.state.SelectGoods_No;
        this.props.RenderComponent("LiveChatDig", ContentState);
        event.preventDefault();
    }
    Listrender() {
        const ChatGoodsList = this.state.ChatGoodsList;
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        return (
            <div className="recent_product result_box">
                <div className="recent_poroducts row row-cols-3 result">
                    {ChatGoodsList.map((list, idx) =>
                        <div className="product" key={idx} onClick={(e) => { this.handleSelectGoods_Click(e, list.goods_no) } }>
                            <div className="product_img"
                                style={{ backgroundImage: `url(${VirtualRoot}${list.img_220})` }}
                            >
                                {list.goods_no === this.state.SelectGoods_No ? <div className="select"><p></p></div> : ""}
                            </div>
                            <div className="shop_name">{list.org_nm}</div>
                            <div className="product_name">{list.goods_nm}</div>
                            <div className="product_price">{list.goods_price}</div>
                            {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    render() {
        let Listrender = this.Listrender();
        return (
            <>
                <div className="p_n_margin d_padding container_box">
                    <div className="search_box seach_box_v3">
                        <input type="search"
                            placeholder="검색어를 입력해주세요."
                            className="form-control"
                            value={this.state.SearchText}
                            onKeyDown={this.handle_KeyDown}
                            onChange={(e) => {this.handleSearch_Blur(e);}}
                            onBlur={(e) => {this.handleSearch_Blur(e);}}
                        />
                        <div className="search_icon"></div>
                        <button className="search_delete sd2" onClick={(e) => { this.handleClear_Click(e) }}></button>
                    </div>
                    {Listrender}
                </div>
                <div className="p_send_btn_box" onClick={(e) => { this.handleSend_Click(e) } }>
                    <div>선택전송</div>
                    <p></p>
                </div>
                <Alert
                    id="LiveChatGoodsAlert"
                    content=""
                    title="상품을 선택하세요."
                />
            </>
        );
    }
}
